import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation MFADeleteUser($userId: ID!) {
    mfaDeleteUser(userId: $userId)
  }
`

export const mfaDeleteUserKey = getQueryNames(mutation)[0]

export default mutation
